/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEyedropper = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20.754 3.244C21.557 4.046 22 5.114 22 6.252s-.443 2.205-1.247 3.008l-1.58 1.609 1.58 1.58-1.413 1.415-1.569-1.569-6.691 6.812-2.302.767-1.367 1.367c-.599.599-1.394.929-2.241.929s-1.643-.33-2.242-.929A3.145 3.145 0 0 1 2 19c0-.847.33-1.642.928-2.241l1.368-1.367.767-2.302 6.692-6.811-1.621-1.621 1.414-1.414 1.608 1.608 1.581-1.609a4.261 4.261 0 0 1 6.017 0zm-7.584 4.45L6.811 14.17l-.767 2.302-1.702 1.701c-.22.221-.342.515-.342.827 0 .313.122.607.342.827a1.199 1.199 0 0 0 1.655 0l1.701-1.701L10 17.359l6.359-6.476zm2.981-3.037-1.58 1.61 3.189 3.189 1.58-1.61A2.24 2.24 0 0 0 20 6.252a2.257 2.257 0 0 0-3.849-1.595z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEyedropper as Eyedropper };
